import React from 'react'

import Rating from 'react-rating'

import PropTypes from 'prop-types'

import Icon from 'Pods/Shared/Icon/Icon'

import { NOOP } from 'Utils/stableDefaults'


function StarsRating({
  setRating = NOOP, rating, readonly = false, fractions = 1, maxRating = 5, customClass = '',
}) {
  const emptyStar = <Icon type={['fas', 'star']} className={`is-grey ${customClass}`} />
  const fullStar = <Icon type={['fas', 'star']} className={`is-yellow ${customClass}`} />

  return (
    <Rating
      emptySymbol={emptyStar}
      fullSymbol={fullStar}
      onChange={setRating}
      initialRating={Number(rating)}
      stop={maxRating}
      readonly={readonly}
      fractions={fractions}
    />
  )
}

StarsRating.propTypes = {
  setRating: PropTypes.func,
  rating: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]).isRequired,
  readonly: PropTypes.bool,
  fractions: PropTypes.number,
  maxRating: PropTypes.number,
  customClass: PropTypes.string,
}

export default StarsRating
